import {HttpClient} from '@angular/common/http';
import {ConfigService} from './config.service';
import {EmiMoratorium} from '../model/emi-moratorium.model';
import {Injectable} from '@angular/core';

@Injectable()
export class EmiMoratoriumService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(httpClient: HttpClient, configService: ConfigService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    public async getEmiMoratoriumsByLoanId(loanId: string): Promise<EmiMoratorium[]> {
        const url = `${this.configService.baseUrl()}emi-moratorium?loanId=${loanId}`;
        return this.httpClient.get<EmiMoratorium[]>(url).toPromise();
    }
}
